const Theme = {
  body_background_color: '#552613',
  title_font: 'Roboto',
  text_font: 'Roboto',
  logo_image_url: 'plsp.png',
  token_url: 'plsp.png',
  number_hidden: true,
  header_full_height: true,
  header_no_margin: true,
  header_no_border: true,
  logo_full_width: true,
  button_border_width: 1,
  button_color: '#552613',
  button_hover_text_color: '#552613',
  button_radius: 100,
  button_outlined_border_color: '#552613',
  button_outlined_hover_border_color: '#552613'
}

export default Theme
// https://app.clickup.com/t/86dtpzcn4